'use client';

import '@ui5/webcomponents-fiori/dist/Page.js';
import { PageBackgroundDesign } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Page` is a container component that holds one whole screen of an application. The page has three distinct areas that can hold content - a header, content area and a footer.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/fiori-Page)
 */
const Page = withWebComponent('ui5-page', ['backgroundDesign'], ['disableScrolling', 'floatingFooter', 'hideFooter'], ['footer', 'header'], []);
Page.displayName = 'Page';
Page.defaultProps = {
  backgroundDesign: PageBackgroundDesign.Solid,
  floatingFooter: true
};
export { Page };